// extracted by mini-css-extract-plugin
export default {"usersCard":"UsersCard_usersCard__cm-Pn","deactivated":"UsersCard_deactivated__qspEb","optionCardComingSoonLabel":"UsersCard_optionCardComingSoonLabel__XUkqg"};